export default __webpack_public_path__ + "static/map/img/continent.f5ad908.svg";